<template>
  <div class="consumer-header d-flex flex-column">
    <div
      class="consumer-header-container"
      :class="{ 'flex-column': !isClubConsumer || isMobile, 'flex-row': isClubConsumer && !isMobile, 'align-center': isClubConsumer && !isMobile }"
    >
      <span v-if="isClubConsumer" class="consumer-header-title cinza-d10-text">{{ consumer.name | pii(hasPiiAccess) }}</span>
      <span v-else class="consumer-header-title cinza-d10-text"
        >{{ documentLabel }} {{ consumer.documentNo || consumer.document_no | cpfCnpj | pii(hasPiiAccess, 'document') }}</span
      >

      <div v-if="isClubConsumer" class="club-consumer-chip hidden-xs-only">
        <mf-icon fill color="verde-l10" size="16.66">verified</mf-icon>
        <span class="verde-d20-text"><strong>Cliente clube</strong></span>
      </div>

      <div v-if="!isClubConsumer" class="not-club-consumer-chip">
        <mf-icon fill color="cinza-l50" size="16.66">do_not_disturb_on</mf-icon>
        <span class="cinza-d10-text"><strong>Cliente não cadastrado no clube</strong></span>
      </div>
    </div>

    <div v-if="isClubConsumer" class="consumer-info">
      <span class="cinza-d10-text">
        {{ documentLabel }}
        <span class="cinza-0-text"> {{ consumer.documentNo || consumer.document_no | cpfCnpj | pii(hasPiiAccess, 'document') }}</span>
      </span>
      <span class="cinza-d10-text">
        Telefone:
        <span class="cinza-0-text"> {{ consumer.phone | telefone | pii(hasPiiAccess, 'phone') }}</span>
      </span>
      <span v-if="email" class="cinza-d10-text">
        E-mail:
        <span class="cinza-0-text"> {{ email | pii(hasPiiAccess, 'email') }}</span>
      </span>
    </div>

    <div v-if="startDate || endDate || unitName" class="consumer-info">
      <span v-if="startDate || endDate" class="cinza-d10-text">
        {{ dateLabel }}
        <span class="cinza-0-text"> {{ dateRange }}</span>
      </span>
      <span v-if="unitName" class="cinza-d10-text">
        Loja selecionada:
        <span class="cinza-0-text"> {{ unitName }}</span>
      </span>
    </div>

    <select-products-dialog v-if="products && products.length > 0" :selected-products="products" button-type="link" view-only />
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import SelectProductsDialog from '@/components/select-products/SelectProductsDialog.vue'

export default {
  name: 'ConsumerHeader',
  components: {
    SelectProductsDialog,
  },
  props: {
    consumer: {
      type: Object,
      required: true,
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    unitName: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => [],
    },
    email: {
      type: String,
      default: '',
    },
  },
  computed: {
    documentLabel() {
      return this.consumer?.documentNo?.length > 11 ? 'CNPJ:' : 'CPF:'
    },
    dateLabel() {
      if (this.endDate && this.endDate.length > 0) {
        return 'Período: '
      }
      return 'Data: '
    },
    dateRange() {
      if (this.endDate && this.endDate.length > 0) {
        return `${DateTime.fromISO(this.startDate).toFormat('dd/MM/yyyy')} - ${DateTime.fromISO(this.endDate).toFormat('dd/MM/yyyy')}`
      } else if (this.startDate && this.startDate.length > 0) {
        return `${DateTime.fromISO(this.startDate).toFormat('dd/MM/yyyy')}`
      }
      return ''
    },
    isClubConsumer() {
      return this.consumer && this.consumer.name
    },
  },
}
</script>

<style lang="scss" scoped>
.cinza-d10-text {
  color: $cinza-d10;
  font-weight: 700;
  font-size: 14px;
}

.cinza-0-text {
  color: $cinza-0;
}

.verde-d20-text {
  color: $verde-d20;
}

.consumer-header {
  gap: 16px;
}

.consumer-header-container {
  display: flex;
  gap: 8px;
}

.consumer-header-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  order: 1;
}

.consumer-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.not-club-consumer-chip {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  background: #ecedf0;
  width: fit-content;
  border-radius: 16px;
  padding: 4px 12px;
  order: 0;
}

.club-consumer-chip {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  background: #ccf0d8;
  width: fit-content;
  border-radius: 16px;
  padding: 4px 12px;
  order: 1;
}

@media screen and (min-width: 933px) {
  .consumer-info {
    flex-direction: row;
    gap: 32px;
  }
}
</style>
